var render = function render(){var _vm=this,_c=_vm._self._c;return _c('batch-title',{ref:"batch_title_ref",attrs:{"page-config":_vm.pageConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }